<template>
  <div class="grade_main">
    <div class="head">当前节次学生请假情况</div>
    <!-- <el-button plain type="danger" class="export" @click="toExport(2)" size="mini" v-if="!isMB&&$permission.can('导出请假','m_workbench')">导出海湾</el-button> -->
    <el-button plain type="danger" class="export" @click="toExport(1)" size="mini" v-if="!isMB&&$permission.can('导出请假','m_workbench')" style="margin-right:8px;">导出</el-button>
    <!-- <div class="tip">
      <span>全校请假人数统计：</span>
    </div> -->
    <div class="tbox">
      <!-- <span class="grade" v-if="Grades.length>0&&isMB">
        {{Grades[0].Grade}}
        <el-link @click="toDetails(Grades[0].GradeId)">展开明细</el-link>
      </span> -->
      <div id="g1" v-if="Grades.length>0" class="flex-item" style="padding-right: 0px;" :style="isMB?'width:100%;margin-top:0;overflow-x:auto;':''">
        <!-- <div :style="isMB?'width:fit-content':''"> -->
          <span class="grade">{{Grades[0].Grade}}</span>
          <el-link @click="toDetails(Grades[0].GradeId)">展开明细</el-link>
          <el-table size="mini" ref="t1" style="margin-bottom:-1px;" :show-header="false" :cell-style="style" :data="[Grades[0].GradeLeaveStat]" border>
            <el-table-column width="70" fixed align="center">
              <template>
                <span>年级汇总</span>
              </template>
            </el-table-column>
            <el-table-column prop="Total" min-width="40" align="center" />
            <el-table-column prop="Bj" min-width="40" align="center" />
            <el-table-column prop="Sj" min-width="40" align="center" />
            <el-table-column prop="Zd" min-width="40" align="center" />
            <el-table-column prop="Yw" min-width="40" align="center" />
            <el-table-column prop="Xl" min-width="40" align="center" />
            <el-table-column prop="Xnjs" min-width="40" align="center" />
            <el-table-column prop="Gj" min-width="40" align="center" />
            <el-table-column prop="Qt" min-width="40" align="center" />
          </el-table>
          <el-table size="mini" :data="Grades[0].ClassLeaveStat" border :header-cell-style="headerStyle" :cell-style="style">
            <el-table-column label="班级" width="70" fixed align="center">
              <template slot-scope="{row,$index}">
                <span class="className" @click="toLeave(row,Grades[0].Grade)">{{Grades[0].ClassLeaveStat[$index].Class}}</span>
              </template>
            </el-table-column>
            <el-table-column label="合计" prop="Total" min-width="40" align="center" />
            <el-table-column label="病假" prop="Bj" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Bj?row.Bj:""}}
              </template>
            </el-table-column>
            <el-table-column label="事假" prop="Sj" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Sj?row.Sj:""}}
              </template>
            </el-table-column>
            <el-table-column label="走读" prop="Zd" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Zd?row.Zd:""}}
              </template>
            </el-table-column>
            <el-table-column label="公假" prop="Gj" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Gj?row.Gj:""}}
              </template>
            </el-table-column>
            <el-table-column label="医务" prop="Yw" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Yw?row.Yw:""}}
              </template>
            </el-table-column>
            <el-table-column label="心理" prop="Xl" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Xl?row.Xl:""}}
              </template>
            </el-table-column>
            <el-table-column label="校本课程" prop="Xnjs" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Xnjs?row.Xnjs:""}}
              </template>
            </el-table-column>
            <el-table-column label="校内其他" prop="Qt" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Qt?row.Qt:""}}
              </template>
            </el-table-column>
          </el-table>
        <!-- </div> -->
      </div>
      <div id="g2" v-if="Grades.length>1" class="flex-item" style="padding:0 0px;" :style="isMB?'width:100%;overflow-x:auto;':''">
          <span class="grade">{{Grades[1].Grade}}</span>
          <el-link @click="toDetails(Grades[1].GradeId)">展开明细</el-link>
          <el-table size="mini" style="margin-bottom:-1px;" :show-header="false" :cell-style="style" :data="[Grades[1].GradeLeaveStat]" border>
            <el-table-column width="70" fixed align="center">
              <template>
                <span>年级汇总</span>
              </template>
            </el-table-column>
            <el-table-column prop="Total" min-width="40" align="center" />
            <el-table-column prop="Bj" min-width="40" align="center" />
            <el-table-column prop="Sj" min-width="40" align="center" />
            <el-table-column prop="Zd" min-width="40" align="center" />
            <el-table-column prop="Yw" min-width="40" align="center" />
            <el-table-column prop="Xl" min-width="40" align="center" />
            <el-table-column prop="Xnjs" min-width="40" align="center" />
            <el-table-column prop="Gj" min-width="40" align="center" />
            <el-table-column prop="Qt" min-width="40" align="center" />
          </el-table>
          <el-table size="mini" :data="Grades[1].ClassLeaveStat" border :header-cell-style="headerStyle" :cell-style="style">
            <el-table-column label="班级" width="70" fixed align="center">
              <template slot-scope="{row,$index}">
                <span class="className" @click="toLeave(row,Grades[1].Grade)">{{Grades[1].ClassLeaveStat[$index].Class}}</span>
              </template>
            </el-table-column>
            <el-table-column label="合计" prop="Total" min-width="40" align="center" />
            <el-table-column label="病假" prop="Bj" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Bj?row.Bj:""}}
              </template>
            </el-table-column>
            <el-table-column label="事假" prop="Sj" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Sj?row.Sj:""}}
              </template>
            </el-table-column>
            <el-table-column label="走读" prop="Zd" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Zd?row.Zd:""}}
              </template>
            </el-table-column>
            <el-table-column label="公假" prop="Gj" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Gj?row.Gj:""}}
              </template>
            </el-table-column>
            <el-table-column label="医务" prop="Yw" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Yw?row.Yw:""}}
              </template>
            </el-table-column>
            <el-table-column label="心理" prop="Xl" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Xl?row.Xl:""}}
              </template>
            </el-table-column>
            <el-table-column label="校本课程" prop="Xnjs" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Xnjs?row.Xnjs:""}}
              </template>
            </el-table-column>
            <el-table-column label="校内其他" prop="Qt" min-width="40" align="center">
              <template slot-scope="{row}">
                {{row.Qt?row.Qt:""}}
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div id="g3" v-if="Grades.length>2" class="flex-item" style="padding-left: 0px;" :style="isMB?'width:100%;overflow-x:auto;':''">
        <span class="grade">{{Grades[2].Grade}}</span>
        <el-link @click="toDetails(Grades[2].GradeId)">展开明细</el-link>
        <el-table size="mini" style="margin-bottom:-1px;" :show-header="false" :cell-style="style" :data="[Grades[2].GradeLeaveStat]" border>
          <el-table-column width="70" fixed align="center">
            <template>
              <span>年级汇总</span>
            </template>
          </el-table-column>
          <el-table-column prop="Total" min-width="40" align="center" />
          <el-table-column prop="Bj" min-width="40" align="center" />
          <el-table-column prop="Sj" min-width="40" align="center" />
          <el-table-column prop="Zd" min-width="40" align="center" />
          <el-table-column prop="Yw" min-width="40" align="center" />
          <el-table-column prop="Xl" min-width="40" align="center" />
          <el-table-column prop="Xnjs" min-width="40" align="center" />
          <el-table-column prop="Gj" min-width="40" align="center" />
          <el-table-column prop="Qt" min-width="40" align="center" />
        </el-table>
        <el-table size="mini" :data="Grades[2].ClassLeaveStat" border :header-cell-style="headerStyle" :cell-style="style">
          <el-table-column label="班级" width="70" fixed align="center">
            <template slot-scope="{row,$index}">
              <span class="className" @click="toLeave(row,Grades[2].Grade)">{{Grades[2].ClassLeaveStat[$index].Class}}</span>
            </template>
          </el-table-column>
          <el-table-column label="合计" prop="Total" min-width="40" align="center" />
          <el-table-column label="病假" prop="Bj" min-width="40" align="center">
            <template slot-scope="{row}">
              {{row.Bj?row.Bj:""}}
            </template>
          </el-table-column>
          <el-table-column label="事假" prop="Sj" min-width="40" align="center">
            <template slot-scope="{row}">
              {{row.Sj?row.Sj:""}}
            </template>
          </el-table-column>
          <el-table-column label="走读" prop="Zd" min-width="40" align="center">
            <template slot-scope="{row}">
              {{row.Zd?row.Zd:""}}
            </template>
          </el-table-column>
          <el-table-column label="公假" prop="Gj" min-width="40" align="center">
            <template slot-scope="{row}">
              {{row.Gj?row.Gj:""}}
            </template>
          </el-table-column>
          <el-table-column label="医务" prop="Yw" min-width="40" align="center">
            <template slot-scope="{row}">
              {{row.Yw?row.Yw:""}}
            </template>
          </el-table-column>
          <el-table-column label="心理" prop="Xl" min-width="40" align="center">
            <template slot-scope="{row}">
              {{row.Xl?row.Xl:""}}
            </template>
          </el-table-column>
          <el-table-column label="校本课程" prop="Xnjs" min-width="40" align="center">
            <template slot-scope="{row}">
              {{row.Xnjs?row.Xnjs:""}}
            </template>
          </el-table-column>
          <el-table-column label="校内其他" prop="Qt" min-width="40" align="center">
            <template slot-scope="{row}">
              {{row.Qt?row.Qt:""}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="margin:15px 0 0 4px;">备注：绿色字体表明该班班主任今日已登录系统；紫色框线表明该班当前节次已完成点名。</div>
    <details-dialog ref="detailsDialog"/>
  </div>
</template>
<script>
import detailsDialog from "./detailsDialog";
export default {
  components: {
    detailsDialog
  },
  data() {
    return {
      data: [],
      state: [],
      ClassSn: 0,
      Grades: [],
      td1: [],
      api: require("@/api/at/attendance").default,
      isMB: this.$store.state.isMB,
      requestTime: "",
    };
  },
  mounted() {},
  methods: {
    setData(data,time) {
      // this.data = data.LeaveStat;
      // this.state = data.LoginStat;
      // this.ClassSn = data.MaxClassSn;
      this.Grades = data.Grades;
      this.requestTime = time;
      // console.log("leave", data);
      this.$nextTick(() => {
        var g1t=$("#g1 .el-table__body-wrapper");
        $("#g1 .el-table__header-wrapper").attr("id","lh12");
        $("#g2 .el-table__header-wrapper").attr("id","lh22");
        $("#g3 .el-table__header-wrapper").attr("id","lh32");
        if(g1t.length>0){
        g1t.each(function (i,e) {
          if(i==0) {
            $(e).attr("id","lh1");
          } else if(i==1) {
            $(e).attr("id","lb1");
          }
        });
          $("#lh1").scroll(function() {
            $("#lh12").scrollLeft($("#lh1").scrollLeft());
            $("#lb1").scrollLeft($("#lh1").scrollLeft());
          });
          $("#lb1").scroll(function() {
            $("#lh1").scrollLeft($("#lb1").scrollLeft());
            $("#lh12").scrollLeft($("#lb1").scrollLeft());
          });
          $("#lh12").scroll(function() {
            $("#lh1").scrollLeft($("#lh12").scrollLeft());
            $("#lb1").scrollLeft($("#lh12").scrollLeft());
          });
        }
        var g2t=$("#g2 .el-table__body-wrapper");
        if(g2t.length>0){
        g2t.each(function (i,e) {
          if(i==0) {
            $(e).attr("id","lh2");
          } else if(i==1) {
            $(e).attr("id","lb2");
          }
        });
          $("#lh2").scroll(function() {
            $("#lh22").scrollLeft($("#lh2").scrollLeft());
            $("#lb2").scrollLeft($("#lh2").scrollLeft());
          });
          $("#lb2").scroll(function() {
            $("#lh2").scrollLeft($("#lb2").scrollLeft());
            $("#lh2").scrollLeft($("#lb2").scrollLeft());
          });
          $("#lh22").scroll(function() {
            $("#lh2").scrollLeft($("#lh22").scrollLeft());
            $("#lb2").scrollLeft($("#lh22").scrollLeft());
          });
        }
        var g3t=$("#g3 .el-table__body-wrapper");
        if(g3t.length>0){
        g3t.each(function (i,e) {
          if(i==0) {
            $(e).attr("id","lh3");
          } else if(i==1) {
            $(e).attr("id","lb3");
          }
        });
          $("#lh3").scroll(function() {
            $("#lh32").scrollLeft($("#lh3").scrollLeft());
            $("#lb3").scrollLeft($("#lh3").scrollLeft());
          });
          $("#lb3").scroll(function() {
            $("#lh3").scrollLeft($("#lb3").scrollLeft());
            $("#lh3").scrollLeft($("#lb3").scrollLeft());
          });
          $("#lh32").scroll(function() {
            $("#lh3").scrollLeft($("#lh32").scrollLeft());
            $("#lb3").scrollLeft($("#lh32").scrollLeft());
          });
        }
        
      })
    },
    clear() {
      this.data = [];
    },
    toExport(t) {
      var time = localStorage.getItem("index-test-time");
      if(time == "null") {
        time = ""
      }
      this.api.exportIndex(time,t);
    },
    toDetails(gradeId) {
      this.$refs.detailsDialog.open().then(that => {
        that.getData({ gradeId, time: this.requestTime });
      })
    },
    headerStyle({row, column, rowIndex, columnIndex}) {
      return { background: "#f9f9f9" }
    },
    toLeave(row,grade) {
      var cn = grade + row.Class;
      sessionStorage.setItem("cn",cn);
      sessionStorage.setItem("cid",row.ClassId);
      this.$router.push("/st/leave");
    },
    style: function ({ row, column, rowIndex, columnIndex }) {
      var cg = row.HasLogin&&columnIndex==1?"color:green;font-weight:bold;":"";
      var bl = columnIndex==1&&row.HasAttendance?"border-left:1px solid purple;":"";
      var num = row[column.property];
      if (num == 0) {
        return "background: none;" + cg + bl;
        // return { background: "", color: row.HasLogin?"green":"", border: row.HasAttendance?"1px solid purple":"1px solid purple" };
      } else if (num >= 1 && num <= 2) {
        // return { background: "#ffd5d5", color: row.HasLogin?"green":"" };
        return "background: #ffd5d5;" + cg + bl;
      } else if (num >= 3 && num <= 4) {
        // return { background: "#ffcaca", color: row.HasLogin?"green":"" };
        return "background: #ffcaca;" + cg + bl;
      } else if (num >= 5 && num <= 6) {
        // return { background: "#ffb9b9", color: row.HasLogin?"green":"" };
        return "background: #ffb9b9;" + cg + bl;
      } else if (num >= 7 && num <= 8) {
        // return { background: "#ff9e9e", color: row.HasLogin?"green":"" };
        return "background: #ff9e9e;" + cg + bl;
      } else if (num >= 9 && num <= 10) {
        // return { background: "#ff8787", color: row.HasLogin?"green":"" };
        return "background: #ff8787;" + cg + bl;
      } else if (num >= 11 && num <= 15) {
        // return { background: "#ff6060", color: row.HasLogin?"green":"" };
        return "background: #ff6060;" + cg + bl;
      } else if (num >= 16 && num <= 20) {
        // return { background: "#ff4050", color: row.HasLogin?"green":"" };
        return "background: #ff4050;" + cg + bl;
      } else if (num > 20) {
        // return { background: "#ff0000", color: row.HasLogin?"green":"" };
        return "background: #ff0000;" + cg + bl;
      } else {
        return "background: none;" + cg + bl;
      }
    },
  },
};
</script>
<style lang="scss">
.grade_main {
  .el-link {
    margin: 0 0 5px 10px;
    // @media screen and (max-width: 767px) {
    //   margin-bottom: 4px;
    // }
  }
  .tbox{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;
  }
  // .el-table {
  //   .el-table__header-wrapper { 
  //     table thead th {
  //       background-color: #f9f9f9;
  //     }
  //   }
  // }
  .className{
    cursor: pointer;
    &:hover {
      color: #8c1515;
    }
  }
  .is-login {
    color: #67c23a;
    font-weight: bold;
  }
  .row_tag {
    float: right;
    margin-left: 5px;
    min-width: 65px;
    text-align: center;
    @media screen and (max-width: 767px) {
      min-width: 45px !important;
    }
  }
  .head {
    line-height: 30px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    cursor: default;
  }
  .grade_top {
    width: 100%;
  }
  .grade_bottom {
    width: 100%;
    margin-top: 10px;
  }
  .tip {
    font-size: 14px;
    text-align: left;
    color: #484848;
    line-height: 54px;
  }
  .export{
    float: right;
    margin-top: -15px;
    font-size: 14px;
    cursor: pointer;
  }
  .grade{
    font-size: 14px;
    margin-bottom: 5px;
    display: inline-block;
    color: #606266;
    font-weight: bold;
  }
  .flex-item{
    // box-sizing: border-box;
    width: calc(33% - 4px);
    @media screen and (max-width: 767px) {
      margin-top: 10px;
    }
    .el-table{
      overflow: hidden;
    }
  }
}
</style>